module.exports = function() {
  return new Worker(__webpack_public_path__ + "2fc41ac1065dcc4c4132.worker.js");
};